import Head from "next/head";
import { make as LbDuo } from "../../../src/leaderboards/LbDuo.bs";
import { lastPatch } from "common/src/Config.ts";
import { fromName, toApiName } from "common/src/Region.bs";

export default function DuoLeaderboards({ data, region, regionLabel }) {
  return (
    <>
      <Head>
        <title>{`TFT top ${regionLabel} Double Up player leaderboards`}</title>
      </Head>
      <LbDuo key={regionLabel} data={data} region={region || undefined} />
    </>
  );
}

export async function getStaticPaths({ locales }) {
  return { paths: [], fallback: "blocking" };
}

export async function getStaticProps({ locale, params }) {
  let region;
  let regionKey;
  let regionLabel;
  if (params.slug && params.slug.length > 0) {
    region = params.slug[0];
    regionLabel = region.toUpperCase();
    regionKey = toApiName(fromName(region));
  } else {
    region = null;
    regionLabel = "global";
    regionKey = "global";
  }
  const resp = await fetch(
    `https://api.tft.tools/duo-leaderboards/v2/${regionKey}`,
  );
  const data = await resp.json();

  return {
    props: {
      data,
      region,
      regionLabel,
    },
    revalidate: 1500,
  };
}
